import { createFileRoute } from "@tanstack/react-router";
import type { IndexTab } from "../../screens/lists/ListsIndexScreen.tsx";
import { ListsIndexScreen } from "../../screens/lists/ListsIndexScreen.tsx";

/** `/lists`: every list the team works through (`?tab=mine|archived`). */
export const Route = createFileRoute("/_app/lists/")({
  validateSearch: (search: Record<string, unknown>): { tab?: IndexTab } =>
    search.tab === "mine" || search.tab === "archived" ? { tab: search.tab } : {},
  component: ListsIndexScreen,
});
